module.exports = __webpack_public_path__ + "static/media/CC.b4e68aed.webp";